// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-SubHeader-SubHeader-module__container-rX22JP","buttons":"src-app-components-layout-SubHeader-SubHeader-module__buttons-uEL09K"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-SubHeader-SubHeader-module__container-rX22JP\",\"buttons\":\"src-app-components-layout-SubHeader-SubHeader-module__buttons-uEL09K\"}";
        // 1789362522880
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  